export interface DailyTip {
  title: string;
  body: string;
  tags: string[];
}

export const MONTHLY_TIPS: DailyTip[] = [
  {
    title: "The Paramountcy Principle",
    body: '"Never lose sight of Section 1 of the Children Act. If you complain about your ex instead of explaining how a situation impacts the child\'s welfare—you\'ve taken a wrong turn."',
    tags: ["Mindset", "Legal Strategy"]
  },
  {
    title: "BIFF Responses Only",
    body: '"When responding to a hostile message, stick to BIFF: Brief, Informative, Friendly, and Firm. Leave your emotions in a separate draft you never send."',
    tags: ["Communication", "Conflict"]
  },
  {
    title: "Document Everything. Factually.",
    body: '"A diary is your best friend. Record dates, times, and exact quotes. Do not include your emotional commentary—stick strictly to the observable facts."',
    tags: ["Evidence", "Documentation"]
  },
  {
    title: "Parallel Parenting Over Co-Parenting",
    body: '"If co-parenting is too toxic, shift to parallel parenting. Completely detach your rules and routines from the other household. Focus entirely on what happens under your roof."',
    tags: ["Parenting", "Boundaries"]
  },
  {
    title: "The 24-Hour Rule",
    body: '"Never reply to a triggering email or text from your ex instantly. Write the draft, close the laptop, and sleep on it. You will almost always delete or shorten the message the next day."',
    tags: ["Emotional Regulation", "Communication"]
  },
  {
    title: "Position Statements: Keep It Brief",
    body: '"Judges are incredibly busy. A 2-page position statement focusing cleanly on the application and the welfare checklist is vastly superior to a 10-page rant about past grievances."',
    tags: ["Court Prep", "Position Statements"]
  },
  {
    title: "Safeguard Your Digital Devices",
    body: '"Change your passwords, secure your icloud, and ensure your location tracking is turned off for anyone who doesn\'t strictly need it. Digital privacy is step one."',
    tags: ["Security", "Privacy"]
  },
  {
    title: "The 'Grey Rock' Method",
    body: '"When faced with a manipulative or abusive ex, become as uninteresting and unresponsive as a grey rock. Give no emotional reaction, positive or negative. Starve the conflict of oxygen."',
    tags: ["Boundaries", "Mental Health"]
  },
  {
    title: "Focus on the Child's Voice",
    body: '"When interacting with Cafcass or Social Services, consistently frame your desires through the lens of the child\'s experience. Say \'Tommy thrives when he has stability\' not \'I have a right to see him.\'"',
    tags: ["Cafcass", "Child-Centric"]
  },
  {
    title: "Treat Handover Like a Business Transaction",
    body: '"Do not use the handover to discuss court cases, finances, or past arguments. It is simply an exchange of the children. Say hello, pass the bags, smile at the kids, and leave."',
    tags: ["Handover", "De-escalation"]
  },
  {
    title: "Prepare for the Worst, Hope for the Best",
    body: '"Expect delays, adjournments, and frustrating court directions. Family law moves at a glacial pace. Mentally pacing yourself for a marathon protects you from burnout."',
    tags: ["Mindset", "Resilience"]
  },
  {
    title: "Know the Welfare Checklist",
    body: '"Section 1(3) of the Children Act is the matrix by which all decisions are made. Memorize the 7 points of the welfare checklist and align all your arguments to them."',
    tags: ["Legal Strategy", "The Children Act"]
  },
  {
    title: "You Are Not Your Case",
    body: '"Do not let the court process become your entire identity. Carve out time every single week where you do not think about, talk about, or plan for the family court."',
    tags: ["Mental Health", "Self Care"]
  },
  {
    title: "Never Criticize the Other Parent to the Kids",
    body: '"No matter how hard it gets, never say a bad word about the other parent to your children. Children view themselves as half you and half them; attacking the ex attacks the child."',
    tags: ["Parenting", "Alienation"]
  },
  {
    title: "Build a Support Network",
    body: '"Isolation kills. Use the Dads Hub, local meetups, and trusted friends. You cannot carry the weight of a hostile separation entirely on your own shoulders."',
    tags: ["Community", "Support"]
  },
  {
    title: "Respect Court Deadlines",
    body: '"If a judge orders a bundle by 4 PM on Tuesday, file it by 10 AM on Tuesday. Missed deadlines as a Litigant in Person signal disrespect to the court and damage your credibility."',
    tags: ["Court Compliance", "Professionalism"]
  },
  {
    title: "Beware of 'The Trap'",
    body: '"Your ex knows exactly which buttons to push to make you look aggressive or out of control just before a hearing or a handover. Recognize the bait and step over the trap."',
    tags: ["Triggers", "Emotional Regulation"]
  },
  {
    title: "Keep a Clean Home",
    body: '"If Social Services or Cafcass conduct a Section 7 home visit, ensure your house is spotless, safe, and clearly set up to warmly accommodate the children. First impressions matter immensely."',
    tags: ["Cafcass", "Preparation"]
  },
  {
    title: "Limit Information Sharing",
    body: '"You do not owe your ex-partner a running commentary on your personal life, your finances (beyond statutory maintenance), or your new relationships. Set strict conversational boundaries."',
    tags: ["Boundaries", "Privacy"]
  },
  {
    title: "Use a Parenting App",
    body: '"If communication is constantly breaking down over WhatsApp, request the court to mandate a dedicated parenting app like OurFamilyWizard to keep threads auditable and professional."',
    tags: ["Tools", "Communication"]
  },
  {
    title: "Understand Without Prejudice",
    body: '"Any settlement offers made \'Without Prejudice\' usually cannot be shown to the Judge in the main proceedings. Keep negotiations and formal court evidence distinctly separate."',
    tags: ["Legal Terms", "Negotiation"]
  },
  {
    title: "Dress for Court",
    body: '"Wear a suit if you have one, or the smartest clothes you own. Treat the courtroom with the utmost respect. Judges notice and appreciate Litigants in Person who take the venue seriously."',
    tags: ["Court Etiquette", "Professionalism"]
  },
  {
    title: "Avoid Social Media Rants",
    body: '"Never post about your case, your ex, or your children on Facebook, X, or Instagram. Opposing solicitors absolutely will harvest your posts and use them to demonstrate hostility."',
    tags: ["Digital Footprint", "Risk Management"]
  },
  {
    title: "Adhere Strictly to Contact Orders",
    body: '"If an order says return the child at 6:00 PM, do not return them at 6:15 PM. Strict, unquestionable reliability builds an impenetrable track record of trustworthiness."',
    tags: ["Compliance", "Trust Building"]
  },
  {
    title: "The Scott Schedule is for Facts, Not Feelings",
    body: '"When drafting or replying to a Scott Schedule (allegations of abuse), stick entirely to physical evidence, dates, and concise denials. Do not use it as a platform to counter-accuse."',
    tags: ["Fact Finding", "Evidence"]
  },
  {
    title: "Speak Slowly in Court",
    body: '"When giving evidence or submissions, the judge is often handwriting notes. Speak slowly. Take pauses. Watch the judge\'s pen, and when they stop writing, you can continue."',
    tags: ["Court Prep", "Advocacy"]
  },
  {
    title: "Focus on Quality Time, Not Just Quantity",
    body: '"If you only have limited contact right now, don\'t spend it stressing about the case or over-compensating with expensive toys. Deep, attentive connection is what the child remembers."',
    tags: ["Parenting", "Connection"]
  },
  {
    title: "Redirect the Interrogation",
    body: '"If children return from the other parent and ask probing questions about the case, calmly redirect them: \'That\'s adult stuff that we are handling. You just focus on being a kid.\'"',
    tags: ["Alienation", "Child Protection"]
  },
  {
    title: "Accept That Unfair Things Will Happen",
    body: '"The family court system is deeply flawed and you will face unfair situations. Accepting this harsh reality early on prevents destructive spirals of bitterness and victimhood."',
    tags: ["Mindset", "Radical Acceptance"]
  },
  {
    title: "Know When to Concede a Small Point",
    body: '"If your ex wants drop-off at 5:00 PM instead of 5:30 PM, and it genuinely doesn\'t harm your relationship with the child, concede it gracefully. It makes you look highly reasonable to the court."',
    tags: ["Negotiation", "Strategy"]
  },
  {
    title: "Breathe. You Are Building a Legacy.",
    body: '"The stress you are enduring now is the price of remaining in your children\'s lives. Years from now, they will realize exactly who stood firm and fought for them. Stay the course."',
    tags: ["Motivation", "Fatherhood"]
  }
];
